import React from 'react';
import {useTranslation} from 'react-i18next';
import _ from 'lodash';
import {Container} from '@material-ui/core';

import ScheduleCarousel from 'components/ScheduleCarousel';

const AvailableShows = ({seances, seancesRencontre, selectedFilmId, onSeanceClick}) => {
  const {t} = useTranslation();

  const seancesCineMinusCurrentMovie = selectedFilmId
    ? seances.filter(seance => seance.film_id !== selectedFilmId)
    : seances;
  const seancesRencontreMinusCurrentMovie = selectedFilmId
    ? seancesRencontre.filter(seance => seance.film_id !== selectedFilmId)
    : seancesRencontre;

  const seancesByDay = Object.values(
    _.groupBy(seancesCineMinusCurrentMovie, s => `"${s.start_time.substring(0, 10)}+${s.film_id}"`),
  );
  const seancesRencontresByDay = Object.values(
    _.groupBy(seancesRencontreMinusCurrentMovie, s => `"${s.start_time.substring(0, 10)}+${s.film_id}"`),
  );

  return (
    <Container maxWidth="lg">
      <div className="spacer" />
      <div className="spacer" />
      {seancesByDay.length > 0 && (
        <ScheduleCarousel
          seancesByDay={seancesByDay}
          nbDays={seancesByDay.length}
          onSeanceClick={onSeanceClick}
          titleHeader={selectedFilmId ? `Dans le même cinéma` : t(`prochaines-seances`)}
        />
      )}
      {seancesRencontresByDay.length > 0 && (
        <ScheduleCarousel
          seancesByDay={seancesRencontresByDay}
          nbDays={seancesRencontresByDay.length}
          onSeanceClick={onSeanceClick}
          titleHeader={t(`seances-rencontres`)}
        />
      )}
    </Container>
  );
};

export default AvailableShows;
